<template>
    <div class='visual-pointer'>
        <svg class="visual-pointer__svg-canvas" viewBox="0 0 1920 1080" preserveAspectRatio="xMidYMid slice" >
            <template v-for="(pointer, index) in pointers">
                <svg
                    :key=index
                    :x="[pointer.left ? pointer.left : 0]"
                    :y="[pointer.top ? pointer.top : 0]"
                    ref="anchor"
                ></svg>
            </template>
        </svg>
        <template v-for="(pointer, index) in pointers">
            <div
                v-if="pointer.reposition.top"
                :class="[{ 'visual-pointer__item_theme_floor': pointer.floor }, 'visual-pointer__item']"
                :key=index
                :style="{ top: pointer.reposition.top, left: pointer.reposition.left}"
                ref="pointers"
            >{{pointer.text}}</div>
        </template>
    </div>
</template>

<style lang='scss'>
    @import "./Pointer.scss";
</style>

<script>
import {mapActions, mapGetters} from 'vuex';
import reposition from '../../helpers/reposition';

export default {
    computed: {
        ...mapGetters({
            pointers: 'GET_POINTERS',
            rotate  : 'GET_ROTATE'
        })
    },

    methods: {
        ...mapActions(['changePosition']),

        /**
         * Метод позиционирует поинтеры согласно координатам svg-якорей.
         */
        position() {
            if (this.pointers && this.pointers.length) {
                const coords = reposition(this.$refs.anchor);

                this.changePosition({
                    type: 'pointers',
                    coords
                });
            }
        }
    },

    watch: {
        rotate() {
            this.$nextTick(() => {
                this.position();
            });
        }
    },

    mounted() {
        this.position();

        window.addEventListener('resize', this.position);
    },

    beforeDestroy() {
        window.removeEventListener('resize', this.position);
    }
};
</script>
